import {
  Typography,
  PrimaryButton,
  Flex,
  IconEmptyEye,
  VerticalSpacing,
} from '@banhala/ui-kit';
import { View } from 'react-native';
import { bridge, isApp, useNavigator } from 'shared/src/utils';

const HeaderHeightMinus = -44;

export const EmptyListView = () => {
  const { navigator } = useNavigator();
  const buttonText = isApp() ? '랭킹 상품 보러가기' : '상품 보러가기';
  const handleButtonPress = () => {
    if (isApp()) {
      bridge.logAnalyticsEvent({
        name: 'VIEW_GOODS_RANKING',
        analytics: {
          SCREEN: 'GOODS_RANKING',
        },
      });
    }
    navigator.moveToRankingGoods();
  };

  return (
    <Flex.Center flex={1}>
      <Flex.Column
        justifyContent="center"
        alignItems="center"
        margin={{
          top: HeaderHeightMinus,
        }}
      >
        <IconEmptyEye width={74} height={74} />
        <VerticalSpacing size={8} />
        <Typography type="subtitle1">최근 본 상품이 없어요</Typography>
        <VerticalSpacing size={8} />
        <Typography type="body2">에이블리의 인기 상품을 보러갈까요?</Typography>
        <VerticalSpacing size={22} />
        <View
          style={{
            width: 248,
          }}
        >
          <PrimaryButton
            onPress={handleButtonPress}
            color="pink"
            variant="fill"
            size="xlarge"
          >
            {buttonText}
          </PrimaryButton>
        </View>
        <Flex.Column></Flex.Column>
      </Flex.Column>
    </Flex.Center>
  );
};
